export default "__VITE_ASSET__DvnctTzR__"